export type MediaProcessingErrorCode = 'invalid-transition' | 'cancelled' | 'unsupported-input' | 'resource-exhausted' | 'processing-timeout' | 'output-invalid' | 'processor-failed';

export class MediaProcessingError extends Error {
  readonly name = 'MediaProcessingError';
  constructor(public readonly code: MediaProcessingErrorCode, message: string, public readonly cause?: unknown) { super(message); }
}

export function isAbortError(error: unknown): boolean {
  return error instanceof MediaProcessingError
    ? error.code === 'cancelled'
    : error instanceof DOMException
      ? error.name === 'AbortError'
      : error instanceof Error && error.name === 'AbortError';
}
